export class FpsController {
    constructor(fps, callback) {
        this.loop = (timestamp) => {
            if (this.time === null)
                this.time = timestamp; // init start time
            const seg = Math.floor((timestamp - this.time) / this.delay); // calc frame no.
            if (seg > this.frame) {
                // moved to next frame?
                this.frame = seg; // update
                this.callback({
                    // callback function
                    time: timestamp,
                    frame: this.frame
                });
            }
            this.tref = requestAnimationFrame(this.loop);
        };
        this.callback = callback;
        this.delay = 1000 / fps;
        this.time = null;
        this.frame = -1;
        this.tref = null;
        this.isPlaying = false;
    }
    start() {
        if (!this.isPlaying) {
            this.isPlaying = true;
            this.tref = requestAnimationFrame(this.loop);
        }
    }
    pause() {
        if (this.isPlaying) {
            cancelAnimationFrame(this.tref);
            this.isPlaying = false;
            this.time = null;
            this.frame = -1;
        }
    }
}
//# sourceMappingURL=FpsController.js.map